// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function omitUndefined<T extends { [index: string]: any }>(
    obj: T
): T {
    const target: T = { ...obj };
    for (const key of Object.keys(target)) {
        if (target[key] === undefined) {
            delete target[key];
        }
    }

    return target;
}
